module.exports = __webpack_public_path__ + "01_long_brown.58580d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_long_brown.png
// module id = BqOp
// module chunks = 0